import { DataTable } from "../DataTable/DataTable";

const LabOrderLifeCycleTable = () => {
  const headers = ["Status", "Description", "Triggers lab_order.updated?"];
  const rows = [
    ["not_purchased", "Lab recommended, but not purchased yet", "❌"],
    ["purchased", "Patient has purchased the lab", "❌ (*see order.placed)"],
    ["schedule_appointment", "The lab purchased requires an appointment to be scheduled", "❌"],
    ["upcoming_appointment", "Appointment scheduled", "❌"],
    ["processing", "Sample received and is being processed", "❌"],
    ["partial_results (results_received)", "Some but not all results available", "✅"],
    ["results_ready (all_results_received)", "All results available", "✅"],
    ["results_amended", "Previously published results have been updated", "✅"],
    ["interpretation_ready", "The results are ready to be interpreted in Fullscript", "❌"],
    ["interpretation_shared", "Practitioner shared interpretation with patient", "❌"],
  ];

  return <DataTable headers={headers} rows={rows} />;
};

export { LabOrderLifeCycleTable };
